var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wscn-http404-container"},[_vm._v("预售商品展位")])
}
var staticRenderFns = []

export { render, staticRenderFns }